import {Classes, Dialog} from "@blueprintjs/core";
import React from "react";

import {DialogBox} from "../../molecules/media-confirm-dialog/dialog-components";

interface ErrorModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
    onCancel: () => void;
    confirmText: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    onCancel,
    title,
    message,
    confirmText,
}) => {
    return (
        <Dialog isOpen={isOpen} onClose={onClose} className={Classes.DIALOG} title={title}>
            <div className={Classes.DIALOG_BODY}>
                <p>{message}</p>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <DialogBox onConfirm={onConfirm} onCancel={onCancel} confirmText={confirmText} />
            </div>
        </Dialog>
    );
};

export default ErrorModal;
